import functions from "./functions.js";
import { Modal } from 'bootstrap/dist/js/bootstrap.bundle.js';

$(function () {

    const $form = $('.form-contact');
    const form = $form[0];

    if (!form) {
        return;
    }

    const urlParameters = new URLSearchParams(window.location.search);
    const preview = urlParameters.get('preview');
    const loaderPreview = preview === 'loader';

    if (urlParameters.get('tura') || ['loader', 'success', 'error'].indexOf(preview) !== -1) {
        function scrollToContactForm() {
            const header = document.querySelector('.main-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'sticky' || headerPosition === 'fixed') ? header.getBoundingClientRect().height : 0;
            const formTop = form.getBoundingClientRect().top + window.pageYOffset - headerOffset - 16;
            window.scrollTo({ top: Math.max(0, formTop), behavior: 'auto' });
        }

        // Wait for images and fonts so the final position stays aligned with the form.
        if (document.readyState === 'complete') {
            requestAnimationFrame(scrollToContactForm);
        } else {
            window.addEventListener('load', () => requestAnimationFrame(scrollToContactForm), { once: true });
        }
    }

    // Visual-only preview: never submit a request or email in this mode.
    if (loaderPreview) {
        $form.on('submit', e => e.preventDefault());
        $form.find('.contact-btn').addClass('d-none');
        $form.find('.contact-spinner').removeClass('d-none').addClass('d-flex');
        return;
    }

    const modalElement = document.getElementById('contact-modal');
    const modal = Modal.getOrCreateInstance(modalElement);
    const $modal = $(modalElement);
    const recaptchaKey = $form.attr('data-recaptcha-key');
    let sending = false;

    function getRecaptchaToken() {
        return $.Deferred(deferred => {
            if (!recaptchaKey || !window.grecaptcha) return deferred.reject();
            window.grecaptcha.ready(() => {
                window.grecaptcha.execute(recaptchaKey, { action: 'contact' }).then(deferred.resolve, deferred.reject);
            });
        }).promise();
    }

    function showResponse(success) {
        const state = success ? 'success' : 'error';
        $modal.find('.modal-title').text($modal.attr('data-' + state + '-title'));
        $modal.find('.response-output').text($modal.attr('data-' + state + '-message'));
        modal.show();
    }

    if (preview === 'success' || preview === 'error') {
        $form.on('submit', e => e.preventDefault());
        showResponse(preview === 'success');
        return;
    }

    $form.on('submit', e => {
        e.preventDefault();
        if (sending || !form.reportValidity()) return;
        const params = functions.getFormData($form);
        if (!params.email || !params.name) return;

        sending = true;
        $form.attr('aria-busy', 'true');
        $form.find('.contact-btn').prop('disabled', true).addClass('d-none');
        $form.find('.contact-spinner').removeClass('d-none').addClass('d-flex');

        getRecaptchaToken().then(token => {
            params.token = token;
            return $.post('/wp-json/services/mail', functions.getDataForUrl(params));
        }).done(response => {
            const success = response && response.status === true;
            showResponse(success);
            if (success) form.reset();
        }).fail(() => {
            showResponse(false);
        }).always(() => {
            sending = false;
            $form.removeAttr('aria-busy');
            $form.find('.contact-btn').prop('disabled', false).removeClass('d-none');
            $form.find('.contact-spinner').removeClass('d-flex').addClass('d-none');
        });
    });
});